import { render, staticRenderFns } from "./ActiveApps.vue?vue&type=template&id=8818ea0a"
import script from "./ActiveApps.vue?vue&type=script&lang=js"
export * from "./ActiveApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports